// import { disableBodyScroll, enableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock';

const submenu = document.querySelectorAll('[js-submenu]')
const header = document.querySelector('header')
const headerCat = document.querySelector('.header-categories')
const headerOverlay = document.querySelector('[js-overlay]')
const navMenuMobile = document.querySelector('[js-nav-button]')
const nav = document.querySelector('[js-nav]')
const navInner = document.querySelector('[js-nav-inner]')
const navButtonExtend = document.querySelectorAll('[js-nav-extend]')

if (submenu.length > 0) {
  for (const menu of submenu) {
    const parent = menu.parentElement
    let timer = null

    parent.addEventListener('mouseover', () => {
      menu.style.display = 'block'
      menu.style.left = `${-parent.offsetLeft}px`
      menu.style.top = `${(header.offsetHeight / 2) - 38}px`
      headerOverlay.style.display = 'block';

      clearTimeout(timer)
      timer = setTimeout(() => {
        menu.classList.add('is-open')
        headerOverlay.classList.add('is-open')
      }, 100)
    })

    parent.addEventListener('mouseleave', () => {
      menu.classList.remove('is-open')
      headerOverlay.classList.remove('is-open')
      clearTimeout(timer)

      timer = setTimeout(() => {
        menu.style.display = 'none'
        headerOverlay.style.display = 'none';
      }, 600)
    })
  }
}

if (nav && navMenuMobile) {
  const state = {
    isOpenMenu: false
  }
  const navInnerRect = navInner.getBoundingClientRect()
  navMenuMobile.addEventListener('click', (e) => {
    e.preventDefault()

    if (state.isOpenMenu) {
      nav.classList.remove('is-open')
      // enableBodyScroll(document.documentElement);
      // enableBodyScroll(document.body);
      navInner.style.height = ''
    } else {
      nav.classList.add('is-open')
      // disableBodyScroll(document.documentElement);
      // disableBodyScroll(document.body);
    }

    state.isOpenMenu = !state.isOpenMenu
  })

  for (const btn of navButtonExtend) {
    btn.addEventListener('click', () => {
      if (btn.classList.contains('is-open')) {
        btn.parentElement.querySelector('.submenu').classList.remove('is-open')
        btn.classList.remove('is-open')
      } else {
        btn.parentElement.querySelector('.submenu').classList.add('is-open')
        btn.classList.add('is-open')
      }
      // navInner.style.height =`${navInner.height + 80}px`
    })
  }
}

document.addEventListener('scroll', () => {
  if (window.scrollY > 200) {
    header.classList.add('is-sticky')
  } else {
    header.classList.remove('is-sticky')
  }
})